import * as React from "react";
import styled from "styled-components";

import Tooltip, { orientation, showOn } from "@8x8/oxygen-tooltip";
import List from "@8x8/oxygen-list";
import QueueForwardIcon from "@8x8/oxygen-icon/novo/QueueForwardIcon";
import DotsVerticalIcon from "@8x8/oxygen-icon/icons/DotsVerticalIcon";

import { COLORS } from "@/react/theme/constants";
import ButtonDropdown from "@/react/components/ButtonDropdown";
import {
  CursorPointerListItem,
  MarginLeftSpan,
} from "@/react/components/table/components/styled";
import { useNavigateToAgentAssignments } from "@/react/features/vcc/common";

const StyledAgentAssignmentsIcon = styled(QueueForwardIcon).attrs({
  size: 18,
})`
  color: ${COLORS.primary};
`;

const AGENT_ACTIONS_COLUMN_ID = "agent-actions";

const AgentActionsCell = ({ rowId, agentData }) => {
  const key = `${AGENT_ACTIONS_COLUMN_ID}-${rowId}`;
  const [isOpen, setIsOpen] = React.useState(false);
  const navigateToAgentAssignments = useNavigateToAgentAssignments();
  const doAndClose = React.useCallback(
    (callback) => (e) => {
      e.stopPropagation();
      callback();
      setIsOpen(false);
    },
    [setIsOpen]
  );

  return (
    <ButtonDropdown
      target={<DotsVerticalIcon size={20} />}
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      key={key}
      dropdownKey={key}
    >
      <List>
        <CursorPointerListItem
          key={`${key}-manage-assignments`}
          onClick={doAndClose(() =>
            navigateToAgentAssignments({
              agentId: agentData?.id,
            })
          )}
        >
          <Tooltip
            orientation={orientation.left}
            showOn={showOn.hover}
            title="View Agent Assignments for this agent."
          >
            <StyledAgentAssignmentsIcon />
            <MarginLeftSpan>View Assignments</MarginLeftSpan>
          </Tooltip>
        </CursorPointerListItem>
      </List>
    </ButtonDropdown>
  );
};

const agentActionsColumnFactory = () => {
  return {
    id: AGENT_ACTIONS_COLUMN_ID,
    header: "",
    cell: ({ row }) => {
      return <AgentActionsCell rowId={row.id} agentData={row?.original} />;
    },
    size: 30,
    enableHiding: false,
    enableSorting: false,
    enableDownload: false,
    enableResizing: false,
    rightSticky: true,
  };
};

export default agentActionsColumnFactory;
